// Footer.js
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
// CSS 모듈 파일 임포트
import styles from "./style/Footer.module.css";
import DOMPurify from 'dompurify'; // 1. DOMPurify 라이브러리 추가

function Footer() {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [message, setMessage] = useState("");

  const API_URL = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = async () => {
    const sanitizedMessage = DOMPurify.sanitize(message);

    try {
      // AWS API Gateway 엔드포인트 URL
      const apiEndpoint = `${API_URL}/feedback`;
      await axios.post(apiEndpoint, {
        type: "feedback", // 버그 리포트, 건의사항 구분
        content: sanitizedMessage,
        timestamp: new Date().toISOString(),
      });
      // 💡 번역 키로 교체
      alert(t("footerComponent.alertSuccess"));
      setIsModalOpen(false);
      setMessage("");
    } catch (error) {
      console.error("메시지 전송 실패:", error);
      // 💡 번역 키로 교체
      alert(t("footerComponent.alertFailure"));
    }
  };

  return (
    <footer className={styles.footer}>
      

      {/* 모달을 여는 버튼 */}
      {/* 💡 번역 키로 교체 */}
      <button onClick={() => setIsModalOpen(true)}>{t("footerComponent.feedbackButton")}</button>

      <p>© {new Date().getFullYear()} Quanport. All rights reserved.</p>
      <p>{t("footer")}</p>
      {/* 모달 팝업 */}
      {isModalOpen && (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            {/* 💡 번역 키로 교체 */}
            <h2>{t("footerComponent.modalTitle")}</h2>
            <textarea
              // 💡 번역 키로 교체
              placeholder={t("footerComponent.modalPlaceholder")}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <button onClick={handleSubmit} className={styles.submitBtn}>
              {/* 💡 번역 키로 교체 */}
              {t("footerComponent.sendButton")}
            </button>
            <button onClick={() => setIsModalOpen(false)} className={styles.closeBtn}>
              {/* 💡 번역 키로 교체 */}
              {t("footerComponent.closeButton")}
            </button>
          </div>
        </div>
      )}
    </footer>
  );
}

export default Footer;